import Link from 'next/link';
import { ComponentPropsWithRef } from 'react';

const LinkComponent = (props: ComponentPropsWithRef<typeof Link>) => (
    <Link prefetch={false} {...props} />
);

export default LinkComponent;
